import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import SkipLink from './components/SkipLink';
import Navbar from './components/Navbar';
import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Summary from './components/Summary';
import Experience from './components/Experience';
import Projects from './components/Projects';
import AiApproach from './components/AiApproach';
import DroneGallery from './components/DroneGallery';
import SectionRail from './components/SectionRail';
import ReactGA from 'react-ga4';

// import Portfolio from './components/Portfolio';
// import { Testimonials } from './components/Testimonials';
import { Contacts } from './components/Contacts';
import { site } from './components/data/site';

function App() {
  ReactGA.initialize('G-3ER1F23ZP6');

  return (
    <>
      <SkipLink />
      <Navbar />
      <SectionRail />
      <div className="page">
        <Header />
        <main id="main-content" tabIndex={-1}>
          <AboutMe />
          <Summary />
          <Experience />
          <Projects />
          <AiApproach />
          <DroneGallery />
          {/* <Portfolio/> */}
          {/* <Testimonials/> */}
          <Contacts />
        </main>
        <footer className="site-footer">
          <p>
            © {new Date().getFullYear()} {site.name} · {site.footerNote}
          </p>
        </footer>
      </div>
    </>
  );
}

export default App;
